import { Body, Heading } from "@elaniintc/goes-design-system";

export const FAQEmptyState = () => {
  return (
    <div className="w-full h-full py-40 flex flex-col items-center justify-center gap-2">
      <Heading variant="h5" color="quiet">
        No se han añadido preguntas al portal
      </Heading>
      <Body color="quiet">
        Añade preguntas a la lista general, o crea nuevas secciones de
        preguntas.
      </Body>
    </div>
  );
};
